<template>
	<div class="bc">
		<div class="w">
			<el-card class="chat">
				<div class="company-container"><h3>在线咨询</h3></div>
				<el-form :label-position="labelPosition" label-width="80px" :model="ZIXUN">
					<el-form-item label="姓 名"><el-input v-model="ZIXUN.name" placeholder="请输入姓名"></el-input></el-form-item>
					<el-form-item label="联系方式"><el-input v-model="ZIXUN.phone" maxlength="11" placeholder="请输入联系方式"></el-input></el-form-item>
					<el-form-item label="详细需求"><el-input type="textarea" :rows="10" placeholder="请输入详细需求" v-model="ZIXUN.title"></el-input></el-form-item>
				</el-form>

				<div class="send">
					<el-button type="info" @click="cancel" style="margin-right: 30px">取消</el-button>
					<el-button type="primary" @click="submit()">提交</el-button>
				</div>
			</el-card>
		</div>
	</div>
</template>
<script>
import { AMessages } from '@/common/js/api';

export default {
	name: 'zixunNei',
	data() {
		return {
			labelPosition: 'left',
			ZIXUN: {
				member_id: JSON.parse(localStorage.getItem('user')).id,
				name: '',
				phone: '',
				title: ''
			}
		};
	},
	created() {},
	methods: {
		//   取消
		cancel() {
			this.$router.go(-1);
		},
		submit() {
						console.log(this.ZIXUN);
			if (this.ZIXUN.phone != null && this.ZIXUN.phone != '' && /^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(this.ZIXUN.phone)) {
				AMessages(this.ZIXUN)
					.then(res => {
						console.log(res);
						if (res.code == 200) {
							this.$message.success('咨询成功');
							this.ZIXUN = '';
							this.$router.go(-1);
						}
					})
					.catch(() => {});
			} else {
				this.$message.error('请输入正确的11位手机号');
			}
		}
	},
	mounted() {
	}
};
</script>
<style lang="less" scoped>
.bc {
	background-image: url('~@/assets/img/home/bei_jing_tu.png');
	background-size: cover;
	margin-top: 135px;
}
/deep/.el-textarea__inner {
	resize: none;
}
.chat {
	padding: 37px 223px;
	.company-container {
		border-bottom: 2px solid rgba(56, 146, 235, 100);
		padding-bottom: 10px;
		margin-bottom: 38px;
		h3 {
			color: rgba(56, 146, 235, 100);
			font-size: 20px;
			font-weight: 700;
			font-family: SourceHanSansSC-regular;
		}
	}
	.send {
		text-align: center;
	}
}
@media screen and (max-width: 1200px) {
	.bc{
		margin-top: 15rem;
	}
	.w{
		width: 98%;
	}
	.chat{
		padding: 3rem;
	}
	.chat .company-container h3{
		font-size: 2rem;
	}
	/deep/.el-form-item{
		margin-bottom: 2rem;
	}
	/deep/.el-input__inner{
		height: 3.5rem;
	}
	/deep/.el-form-item__label{
		width: 8rem !important;
		font-size: 1.5rem;
	}
	/deep/.el-form-item__content{
		margin-left: 9rem !important;
	}
	/deep/.el-input{
		font-size: 1.5rem;
		height: 2rem;
	}
	/deep/.el-textarea__inner{
		font-size: 1.5rem;
	}
	/deep/.el-button{
		font-size: 1.5rem;
	}
}
</style>
